import React, { useEffect } from 'react';
import { useSlotScreenGeneratorStore } from '@store/slotScreenGeneratorStore';
import { SLOT_SCREEN_ORDER } from '@core/types/slot-screen-generator.types';
import { VideoSlotCard } from './VideoSlotCard';

export function VideoSlotGrid() {
  const syncVideoSlotsFromScreens = useSlotScreenGeneratorStore(s => s.syncVideoSlotsFromScreens);

  // Auto-populate slots from screen results on mount
  useEffect(() => {
    syncVideoSlotsFromScreens();
  }, [syncVideoSlotsFromScreens]);

  return (
    <div className="flex gap-2 p-2 overflow-x-auto">
      {SLOT_SCREEN_ORDER.map(id => (
        <VideoSlotCard key={id} screenId={id} />
      ))}
    </div>
  );
}
